var _a;
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import SurveyItem from './SurveyItem';
// control all survey behaviours
// all survey questions
let surveyItems = [].slice.call(document.querySelectorAll('.survey-item'));
surveyItems.forEach(element => {
    if (element.classList.contains("survey-item--Dichotmous")
        || element.classList.contains("survey-item--MultiChoice")) {
        console.log("MultiChoice");
        // multiple choices
        new MultipleChoiceQuestion(element).init();
    }
    else {
        console.log("General Question");
        // general items
        new SurveyItem(element).init();
    }
});
// show survey questions panel
(_a = document.querySelector("#surveyQuestionsPanel")) === null || _a === void 0 ? void 0 : _a.removeAttribute("style");
export default undefined;
